module.exports = __webpack_public_path__ + "static/media/IMG_4258.3d500f20.PNG";